// extracted by mini-css-extract-plugin
module.exports = {"container":"_80ad21f8ef--container--1-2F2","title":"_80ad21f8ef--title--1PEEb","description":"_80ad21f8ef--description--1i0w8","controls":"_80ad21f8ef--controls--1eY3J"};